import {params} from './state';

/**
 * Establecer un valor para la variable preloader.
 */
export function setPreloader(state, preloader) {
    state.preloader = preloader;
}

/**
 * Establecer un valor para la variable documents.
 */
export function setDocuments(state, documents) {

    documents.data.map(d => d.selected = false);

    state.documents = documents;
}

/**
 * Establecer un valor para la variable branch_offices.
 */
export function setBranchOffices(state, branch_offices) {
    state.branch_offices = branch_offices;
}

/**
 * Establecer un valor para la variable branch_offices_warehouses.
 */
export function setBranchOfficesWarehouses(state, branch_offices_warehouses) {
    state.branch_offices_warehouses = branch_offices_warehouses;
}

/**
 * Establecer un valor para la variable models.
 */
export function setModels(state, models) {
    state.models = models;
}

/**
 * Establecer un valor para la variable voucher_types.
 */
export function setVoucherTypes(state, voucher_types) {
    state.voucher_types = voucher_types;
}

/**
 * Establecer un valor para la variable contacts.
 */
export function setContacts(state, contacts) {
    state.contacts = contacts;
}

/**
 * Establecer el valor por defecto de la variable params.
 */
export function resetParams(state) {
    state.params = params();
}

/**
 * Establecer un valor para el atributo page de la variable params.
 */
export function setPageToParams(state, page) {
    state.params.page = page;
}

/**
 * Establecer valores por defecto para atributos de params.
 */
export function setDataDefault(state) {
    state.params.branch_office_id = +localStorage.selected_branchoffice;
    state.params.branch_office_warehouse_id = +localStorage.selected_branchoffice_warehouse;
}

/**
 * Establecer un valor para el atributo show de la variable modal.
 */
export function setShowToModal(state, show) {
    state.modal.show = show;
    state.documents = {
        data: []
    }
}

/**
 * Establecer un valor para el atributo voucher_type_id de la variable params.
 */
export function setVoucherTypeIdToParams(state, voucher_type_id) {
    state.params.voucher_type_id = voucher_type_id;
}

/**
 * Establecer un valor para el atributo model_id de la variable params.
 */
export function setModelIdToParams(state, model_id) {
    state.params.model_id = model_id;
}

/**
 * Establecer un valor para la variable base_document.
 */
export function setBaseDocument(state, base_document) {
    state.base_document = base_document;

    if (base_document){
        state.params.state_id = 1
    }else{
        state.params.state_id = null
    }
}

/**
 * Establecer un valor para el atributo selected de la variable documents.
 */
export function selectAll(state) {
    state.documents.data.map(d => d.selected = true);
}

/**
 * Establecer un valor para la variable documents.
 */
export function setDocumentsWithOutSelected(state, documents) {
    state.documents = documents;
}

export function setUnds(state, unds) {    
   const dataCopy = [...state.documents.data]
   
   const newData = dataCopy.map(doc => {
      let und = unds.find(el => el.document_id == doc.id)
      if (und) {        
        doc.total_backorder_quantity = und.total_backorder_quantity
        doc.total_unds = und.total_unds
        doc.loading_unds = false
      }

      return doc
    })

    state.documents.data = newData
}


// WEBPACK FOOTER //
// ./src/modules/document_finder/mutations.js